import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { modalProps } from "../../../../Component/Interface/Modal";
import { BackgroundArea, TitleArea } from "../../../../Component/style/common_style";

const ModalBox = styled.div`
  box-sizing: border-box;
  width: 100%;
  max-width: 25rem;
  margin: auto 0;
  padding: 1.5rem;
  border-radius: 24px;
  background: var(--user-surface);
  color: var(--user-text);
  .info { white-space: pre-line; line-height: 25px; }
`;

const BtnArea = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 1rem;
  button {
    min-height: 44px;
    width: 100%;
    border: 0;
    border-radius: 8px;
    background: var(--user-surface-raised);
    color: var(--user-text);
    font-family: var(--font-Pretendard-SemiBold);
    cursor: pointer;
  }
  button.primary { background: linear-gradient(90deg, #7955f0, #3209b9); color: white; }
  button:focus-visible { outline: 2px solid var(--user-accent); outline-offset: 2px; }
`;

const Block = ({ visible, handleModal, ban_popup, isLogout, storeSeq }: modalProps & {
  ban_popup: string;
  isLogout?: boolean;
  storeSeq?: number;
}) => {
  const navigate = useNavigate();
  const leave = (inquiry = false) => {
    handleModal();
    if (Number.isSafeInteger(storeSeq) && Number(storeSeq) > 0) {
      navigate(`/store/${storeSeq}${inquiry ? "/inquiry" : ""}`, { replace: true });
    } else if (isLogout) {
      navigate("/", { replace: true });
    } else {
      window.location.reload();
    }
  };

  return <BackgroundArea style={visible ? {} : { display: "none" }}
    onClick={event => { if (event.target === event.currentTarget) leave(); }}>
    <ModalBox role="dialog" aria-modal={visible} aria-label="차단 알림" onClick={event => event.stopPropagation()}>
      <TitleArea><div>차단 알림</div></TitleArea>
      <div className="info">{ban_popup}</div>
      <BtnArea>
        {storeSeq ? <>
          <button type="button" className="primary" onClick={() => leave(true)}>해당 셀러에게 문의하기</button>
          <button type="button" onClick={() => leave()}>셀러 페이지로 이동</button>
        </> : <button type="button" onClick={() => leave()}>닫기</button>}
      </BtnArea>
    </ModalBox>
  </BackgroundArea>;
};

export default Block;
